import Payments from '../prizesPayments/PrizesPayments.vue';

export default {
  data() {
    return {
      dialogAdded: false,
    };
  },
  components: {
    Payments,
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    requirePers() {
      return this.$store.state.settings.profile_pers === true && !this.$store.state.user.pers_at;
    },
    hasEps() {
      return this.$store.state.settings.eps === true;
    },
    hasPayments() {
      return this.$store.state.settings.payments === true;
    },
    hasShop() {
      return this.$store.state.settings.shop === true;
    },
    cards() {
      return this.$store.state.eps.cards;
    },
    cardHint() {
      if (!this.cards.nominals_text || !this.cards.nominals_text.length) {
        return '';
      }
      for (let i = 0; i < this.cards.nominals_text.length; i += 1) {
        if (this.cards.nominals_text[i].price === parseInt(this.card.snominal, 10)) {
          return `${this.cards.nominals_text[i].text}`;
        }
      }
      return '';
    },
  },
  methods: {
    GetDetails(type) {
      this.$router.push(`eps/${type}`);
    },
    Add(card) {
      const app = this;
      if (card.nominal === undefined || !card.nominal) {
        document.getElementById(`select-card-${card.id}`).click();
        return;
      }
      app.$store.dispatch('eps/AddToCart', { card, qty: card.qty });
      app.dialogAdded = true;
      card.nominal = null;
      card.qty = 1;
    },
    ChangeQty(e, card) {
      if (+e.target.value > 0) {
        card.qty = +e.target.value;
      } else {
        card.qty = 1;
      }
    },
  },
  mounted() {
    const app = this;
    if (app.requirePers) {
      app.$router.push('/dashboard', () => {
        setTimeout(() => {
          app.$store.dispatch('ShowError', 'Для раздела "Призы" необходимо согласие на обработку персональных данных!');
        }, 500);
      });
    }
    if (app.hasEps) {
      app.$store.dispatch('eps/GetCards');
    }
  },
};
